import React, { useState } from "react";
import DeletedCasesList from "../../../components/cases/DeletedCasesLIst";
import { useOutletContext } from "react-router-dom";
const DeletedCases = () => {
  const [refresh, setRefresh] = useState(false);
  const [
    data,
    handleRefreh,
    location,
    search,
    handleSearch,
    searchFilterState,
    handleFilterStateActive,
    entireCasesText,
    handleEntireCasesText,
    handleSetConsultantFilter,
    selectedConsultant,
    consultantsList,
    selectedConsultantName,
  ] = useOutletContext();
  const handleRefreshByParent = () => {
    setRefresh((pre) => !pre);
    handleRefreh();
  };
  return (
    <DeletedCasesList
      data={data}
      handleRefresh={handleRefreshByParent}
      search={search}
      handleSearch={handleSearch}
      searchFilterState={searchFilterState}
      handleEntireCasesText={handleEntireCasesText}
      entireCasesText={entireCasesText}
      handleFilterStateActive={handleFilterStateActive}
      handleSetConsultantFilter={handleSetConsultantFilter}
      selectedConsultant={selectedConsultant}
      consultantsList={consultantsList}
      selectedConsultantName={selectedConsultantName}
    />
  );
};

export default DeletedCases;
